import React from "react";
import Skeleton from "../shared/skeleton-component";

const StmSummarySkeleton = () => {
  return (
    <div className="summary-stm-main-skeleton">
      <div className="summary-stm-wrapper">
        <Skeleton width="320px" height="40px" />
        <div className="stm-sum-data-box">
          <Skeleton width="320px" height="280px" />
        </div>
      </div>
    </div>
  );
};

export default StmSummarySkeleton;
